import { Button } from '@/components/ui/Button'
import { useSignupComplete } from '@/features/signup/useSignupComplete'
import { getCurrentUser } from '@/services/api'
import { Icon } from '@components/icons/Icon'
import { MainLayout } from '@components/layouts/MainLayout'
import { useWallet } from '@components/providers/WalletProvider'
import { IconButton } from '@components/ui/IconButton'
import { InfoCard } from '@components/ui/InfoCard'
import { Input } from '@components/ui/Input'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export function SignupComplete() {
  const { smartWalletAddress, logout, isAuthenticated } = useWallet()
  const address = smartWalletAddress || ''
  const { onBack, onCopy } = useSignupComplete(address)
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)
  const [currentStatus, setCurrentStatus] = useState<{
    title: string
    description: string
    className?: string
  } | null>(null)

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  const handleGetUserInfo = async () => {
    if (!isAuthenticated) {
      setCurrentStatus({
        title: 'ログインしてください',
        description: '下のログアウトボタンを押下後、再度ログインをお願いします。',
        className: 'bg-red-50 text-red-800',
      })
      return
    }

    setIsLoading(true)
    setCurrentStatus(null)

    console.log('getCurrentUser')

    try {
      const response = await getCurrentUser()
      console.log('user response', response)
      if (response.user.isActive) {
        setCurrentStatus({
          title: 'お待たせしました！',
          description: 'サービスをご利用いただく準備が整いました。',
          className: 'bg-green-50 text-green-800',
        })
        navigate('/home', { replace: true })
        return
      }
      setCurrentStatus({
        title: 'お待たせしております。',
        description: 'まもなくサービスをご利用いただけます。',
        className: 'bg-yellow-50 text-yellow-800',
      })
    } catch (err) {
      console.error('Failed to get user info:', err)
      setCurrentStatus({
        title: 'もうしばらくお待ち下さい。',
        description: 'ただいま、準備中です。',
        className: 'bg-yellow-50 text-yellow-800',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <MainLayout
      activeMain={null}
      secondaryLayout="default"
      showBottomNav={false}
      outerClassName="bg-[#F5F5F5]"
      className="bg-[#F5F5F5]"
      contentClassName="flex flex-col px-4 pb-10"
      header={{
        enabled: true,
        title: '登録完了',
        leftIcon: null,
        rightIcon: null,
        leftSlot: <IconButton aria-label="戻る" icon="Back" onClick={onBack} />,
        rightSlot: null,
        className: 'flex h-16 w-full items-center justify-between px-6',
        containerClassName: 'px-4 pt-4',
        scrolledClassName: 'supports-[backdrop-filter]:backdrop-blur-[1px]',
        offset: 112,
      }}
    >
      <div className="flex h-full flex-col">
        <div className="flex w-full flex-1 flex-col gap-10 pt-6">
          <div className="text-center">
            <p className="text-sm text-zinc-600">ウォレットの作成が完了しました。</p>
          </div>

          <div className="mt-6">
            <p className="mb-2 text-center text-sm font-bold">あなたのウォレットアドレス</p>
            <div className="space-y-2">
              <Input label="ウォレットアドレス" placeholder={address} disabled value={address} />
              <div className="flex flex-col items-center">
                <button
                  type="button"
                  onClick={onCopy}
                  className="inline-flex items-center gap-1 text-sm font-semibold text-blue-600 hover:underline"
                  aria-label="クリップボードにコピー"
                >
                  クリップボードにコピー
                  <span className="inline-block size-4 align-middle">
                    <Icon content="Copy" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8">{currentStatus ? <InfoCard {...currentStatus} /> : <InfoCard />}</div>

        <div className="mt-6">
          <div className="text-center">
            <Button
              onClick={handleGetUserInfo}
              label={isLoading ? '取得中...' : '最新のステータスを確認'}
              leftIcon={false}
              rightIcon={false}
            />
          </div>
        </div>

        <div className="my-6 flex justify-center">
          <button
            type="button"
            onClick={handleLogout}
            className="inline-flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-800 hover:underline"
            aria-label="ログアウト"
          >
            ログアウト
          </button>
        </div>
      </div>
    </MainLayout>
  )
}

export default SignupComplete
